<template>
    <!-- Importar Excel: se lee en el navegador (xlsx), la API simula qué pasaría
         (POST importar con simular) y recién después se aplica. -->
    <CrmModal :titulo="paso === 'ver' ? crm.t('imp.review') : crm.t('imp.t')" :sub="paso === 'ver' ? crm.tc('imp.rows', x.filas.length, { h: x.hoja }) : crm.t('imp.sub')" :mw="paso === 'ver' ? 820 : 720" @cerrar="$emit('cerrar')">
        <template v-if="paso !== 'ver'">
            <div class="cr-drop" :class="{ 'is-over': sobre }" tabindex="0" role="button" :aria-label="crm.t('imp.drop')"
                 @click="elegir" @keydown.enter.prevent="elegir" @keydown.space.prevent="elegir"
                 @dragover.prevent="sobre = true" @dragleave="sobre = false" @drop.prevent="soltar">
                <span class="cr-drop-ico" v-html="I.file"></span>
                <b>{{ paso === 'leyendo' ? crm.t('imp.reading') : crm.t('imp.drop') }}</b>
                <span>{{ crm.t('imp.types') }}</span>
            </div>
            <input ref="file" type="file" accept=".xlsx,.xls,.csv" hidden @change="archivo($event.target.files[0])" />
            <div><p class="cr-imp-cols">{{ crm.t('imp.cols') }}</p>
                <div class="cr-req"><span v-for="c in columnas" :key="c" class="cr-tag"><b v-if="c === 'Empresa'">{{ c }}</b><template v-else>{{ c }}</template></span></div></div>
            <p class="cr-note"><span v-html="I.info"></span><span>{{ crm.t('imp.how') }}</span></p>
            <p v-if="error" class="cr-note cr-note--bad"><span v-html="I.warn"></span><span>{{ error }}</span></p>
        </template>

        <template v-else>
            <div class="cr-imp-file"><span v-html="I.file"></span><div><b>{{ nombre }}</b><small>{{ crm.t('imp.file_s', { kb: kb, n: Object.keys(x.mapa).length }) }}</small></div>
                <button type="button" class="cr-btn-link" @click="otro">{{ crm.t('imp.other') }}</button></div>
            <dl class="cr-imp-sum">
                <div class="cr-fact is-new"><dt>{{ crm.t('imp.g.nuevas') }}</dt><dd>{{ R.resumen.nuevas }}</dd></div>
                <div class="cr-fact is-upd"><dt>{{ crm.t('imp.g.cambian') }}</dt><dd>{{ R.resumen.cambian }}</dd></div>
                <div class="cr-fact"><dt>{{ crm.t('imp.g.iguales') }}</dt><dd>{{ R.resumen.iguales }}</dd></div>
                <div class="cr-fact" :class="{ 'is-late': R.resumen.problemas }"><dt>{{ crm.t('imp.g.problemas') }}</dt><dd>{{ R.resumen.problemas }}</dd></div>
            </dl>
            <p v-if="R.estados_nuevos.length" class="cr-note cr-note--warn"><span v-html="I.warn"></span><span>{{ crm.t('imp.new_states') }} <b>{{ R.estados_nuevos.join(', ') }}</b>.</span></p>
            <details class="cr-more"><summary>{{ crm.t('imp.map') }}</summary>
                <div class="cr-map"><template v-for="c in columnas"><span :key="'a' + c">{{ c }}</span>
                    <b v-if="x.mapa[c] !== undefined" :key="'b' + c">{{ crm.t('imp.col', { l: letra(x.mapa[c]) }) }}</b><b v-else :key="'b' + c" class="cr-off">{{ crm.t('imp.missing') }}</b></template>
                    <template v-if="x.ignoradas.length"><span key="ig">{{ crm.t('imp.ignored') }}</span><b key="igv" class="cr-off">{{ x.ignoradas.join(', ') }}</b></template></div>
            </details>
            <div class="cr-opts cr-opts--row" role="radiogroup" :aria-label="crm.t('imp.what')">
                <label class="cr-opt"><input v-model="modo" type="radio" value="todo" /><div><b>{{ crm.t('imp.mode_all') }}</b><span>{{ crm.t('imp.mode_all_s') }}</span></div></label>
                <label class="cr-opt"><input v-model="modo" type="radio" value="nuevas" /><div><b>{{ crm.t('imp.mode_new') }}</b><span>{{ crm.t('imp.mode_new_s') }}</span></div></label>
            </div>
            <label v-if="R.resumen.movidas && modo === 'todo'" class="cr-opt"><input v-model="mover" type="checkbox" /><div><b>{{ crm.tc('imp.move', R.resumen.movidas) }}</b><span>{{ crm.t('imp.move_s') }}</span></div></label>
            <div class="cr-imp-tabs" role="tablist">
                <button v-for="g in GRUPOS" :key="g" type="button" class="cr-chip" role="tab" :aria-selected="String(tab === g)" :aria-pressed="String(tab === g)" @click="tab = g">{{ crm.t('imp.g.' + g) }}<span class="cr-n">{{ R.resumen[g] }}</span></button>
            </div>
            <div class="cr-imp-table-wrap">
                <table v-if="lista.length" class="cr-imp-table">
                    <thead><tr><th>{{ crm.t('imp.h.row') }}</th><th>Empresa</th><th>{{ tab === 'cambian' || tab === 'iguales' ? crm.t('imp.h.now') : 'Status' }}</th><th>{{ crm.t('imp.h.detail') }}</th></tr></thead>
                    <tbody>
                        <tr v-for="r in lista.slice(0, 150)" :key="tab + r.fila">
                            <td class="cr-lt-num">{{ r.fila }}</td>
                            <td><b>{{ r.empresa || crm.t('imp.empty_name') }}</b></td>
                            <td v-if="tab === 'cambian' || tab === 'iguales'" v-html="crm.estPill(r.estado_actual)"></td>
                            <td v-else v-html="pillStatus(r)"></td>
                            <td>
                                <template v-if="tab === 'nuevas'"><small>{{ [r.datos.ciudades, r.datos.contacto, r.datos.email].filter(Boolean).join(' · ') || '—' }}</small><span v-if="r.aviso" class="cr-tag cr-tag--warn">{{ crm.t('imp.bad_mail') }}</span></template>
                                <template v-else-if="tab === 'cambian'">
                                    <small v-for="(c, j) in r.cambios" :key="j"><b>{{ crm.t('fld.' + c.k) }}:</b> <template v-if="c.de"><s>{{ val(c, 'de') }}</s> → </template>{{ val(c, 'a') }}</small>
                                    <small v-if="r.mueve"><b>Status:</b> {{ crm.estado(r.estado_actual).nombre }} → {{ nombreStatus(r) }} <span class="cr-tag">{{ crm.t('imp.only_if') }}</span></small>
                                </template>
                                <small v-else-if="tab === 'iguales'">{{ crm.t('imp.same', { e: crm.estado(r.estado_actual).nombre }) }}</small>
                                <span v-else class="cr-tag cr-tag--bad">{{ crm.t('imp.why.' + r.por) }}</span>
                                <span v-if="r.aviso_asig" class="cr-tag cr-tag--warn">{{ crm.t('imp.bad_asig', { n: r.aviso_asig }) }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p v-else class="cr-tl-empty">{{ crm.t('imp.none') }}</p>
                <p v-if="lista.length > 150" class="cr-tl-empty">{{ crm.t('imp.and_more', { n: lista.length - 150 }) }}</p>
            </div>
            <p v-if="error" class="cr-note cr-note--bad"><span v-html="I.warn"></span><span>{{ error }}</span></p>
        </template>

        <template v-if="paso === 'ver'" #pie>
            <small>{{ total ? crm.t('imp.summary', { a: R.resumen.nuevas, b: actualizan }) : (R.resumen.movidas && modo === 'todo' && !mover ? crm.t('imp.only_move') : crm.t('imp.nothing')) }}</small>
            <button type="button" class="cr-btn cr-btn-ghost" @click="$emit('cerrar')">{{ crm.t('cancel') }}</button>
            <button type="button" class="cr-btn cr-btn-main" :disabled="!total || enviando" @click="importar">{{ total ? crm.t('imp.go_n', { n: total }) : crm.t('imp.go') }}</button>
        </template>
    </CrmModal>
</template>

<script>
import CrmModal from './CrmModal.vue';
import { I, esc, ALIAS, leerExcel, letraColumna } from './crmUtil';

const GRUPOS = ['nuevas', 'cambian', 'iguales', 'problemas'];

export default {
    name: 'CrmImportar',
    components: { CrmModal },
    inject: ['crm'],
    data() { return { I, GRUPOS, columnas: Object.keys(ALIAS), paso: 'elegir', sobre: false, error: '', x: null, R: null, nombre: '', kb: 0, modo: 'todo', mover: false, tab: 'nuevas', enviando: false }; },
    computed: {
        lista() { return this.R ? this.R[this.tab] || [] : []; },
        actualizan() { return this.modo === 'todo' ? this.R.cambian.filter(r => r.cambios.length || (this.mover && r.mueve)).length : 0; },
        total() { return this.R ? this.R.resumen.nuevas + this.actualizan : 0; },
    },
    methods: {
        letra: letraColumna,
        elegir() { if (this.paso === 'leyendo') return; this.$refs.file.value = ''; this.$refs.file.click(); },
        soltar(e) { this.sobre = false; const f = e.dataTransfer.files[0]; if (f) this.archivo(f); },
        otro() { this.paso = 'elegir'; this.R = null; this.x = null; this.error = ''; this.$nextTick(this.elegir); },
        archivo(f) {
            if (!f) return;
            this.error = ''; this.paso = 'leyendo'; this.nombre = f.name; this.kb = Math.max(1, Math.round(f.size / 1024));
            const r = new FileReader();
            r.onload = async () => {
                try { this.x = leerExcel(new Uint8Array(r.result)); }
                catch (e) { this.paso = 'elegir'; this.error = this.crm.t(e.sinEmpresa ? 'imp.err_cols' : 'imp.err_read', { f: f.name }); return; }
                if (!this.x.filas.length) { this.paso = 'elegir'; this.error = this.crm.t('imp.err_empty', { f: f.name }); return; }
                try {
                    this.R = await this.crm.api('post', '/importar', { archivo: f.name, filas: this.x.filas, modo: 'todo', simular: true });
                    this.tab = GRUPOS.find(g => this.R.resumen[g]) || 'nuevas';
                    this.paso = 'ver';
                } catch (e) {
                    this.paso = 'elegir';
                    const d = e.response && e.response.data;
                    this.error = (d && d.message && e.response.status === 422) ? d.message : this.crm.t('imp.err_api');
                }
            };
            r.onerror = () => { this.paso = 'elegir'; this.error = this.crm.t('imp.err_read', { f: f.name }); };
            r.readAsArrayBuffer(f);
        },
        nombreStatus(r) { const e = this.crm.estados.find(x => x.clave === r.estado_clave); return e ? e.nombre : r.status.replace(/^[^\p{L}\p{N}]+/u, ''); },
        pillStatus(r) {
            if (!r.status) return `<span class="cr-tag">${esc(this.crm.t('imp.default_state'))}</span>`;
            const e = this.crm.estados.find(x => x.clave === r.estado_clave);
            return e ? this.crm.estPill(e.id) : `<span class="cr-est tn-pink"><span class="cr-dot"></span>${esc(this.nombreStatus(r))}</span>`;
        },
        val(c, lado) { return c.k === 'prioridad' ? this.crm.t('pri.' + (c[lado] || 'none')) : c[lado]; },
        async importar() {
            if (this.enviando) return;
            this.enviando = true; this.error = '';
            try {
                const r = await this.crm.api('post', '/importar', { archivo: this.nombre, filas: this.x.filas, modo: this.modo, mover: this.mover });
                await this.crm.cargar(true);
                this.$emit('cerrar');
                this.crm.toast(this.crm.t('imp.done', { a: r.nuevas, b: r.actualizadas }), this.crm.t('imp.see'), () => this.crm.abrirActividad(this.crm.yo));
                if (r.ids && r.ids[0]) this.$nextTick(() => this.crm.$refs.board && this.crm.$refs.board.resaltar(r.ids[0]));
            } catch (e) {
                const d = e.response && e.response.data;
                this.error = (d && d.message && e.response.status === 422) ? d.message : this.crm.t('imp.err_api');
            }
            this.enviando = false;
        },
    },
};
</script>
